<template>
  <van-popup
    round
    :value="value"
    :closeable="false"
    :close-on-click-overlay="closeOnClickOverlay"
    position="bottom"
    class="c-bottom-popup"
    @click-overlay="throttledOnClose"
    :get-container="getContainer"
  >
    <div
      class="c-bottom-popup-container c:col-center"
      :style="{ '--computed-max-height': computedMaxHeight }"
    >
      <div class="c-bottom-popup-header c:row-center">
        <div class="popup-header-left"></div>
        <div class="popup-title">{{ title }}</div>
        <div class="popup-header-right" @click="throttledOnClose">
          <img src="@/assets/icons/closer.svg" alt="" />
        </div>
      </div>
      <div class="c-bottom-popup-body">
        <slot />
      </div>
    </div>
  </van-popup>
</template>
<script>
import { throttle } from "@/utils";

export default {
  data() {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    maxHeight: {
      type: [Number, String],
      default: "50vh",
    },
    getContainer: {
      type: String,
      default: undefined,
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedMaxHeight() {
      switch (typeof this.maxHeight) {
        case "string":
          if (+this.maxHeight == this.maxHeight)
            return `${this.maxHeight / 20}rem`;
          return this.maxHeight;

        case "number":
          return `${this.maxHeight / 20}rem`;

        default:
          return `${1 / 20}rem`;
      }
    },
  },
  created() {
    this.throttledOnClose = throttle(this.onClose, 500);
  },
  methods: {
    onClose() {
      this.$emit("input", false);
      this.$emit("closed");
    },
  },
};
</script>
<style lang="less" scoped>
.c-bottom-popup {
  .c-bottom-popup-container {
    max-height: var(--computed-max-height);
    min-height: 249/20rem;
    .c-bottom-popup-header {
      box-sizing: border-box;
      width: 100%;
      height: 60/20rem;
      padding: 19/20rem 15/20rem;

      .popup-title {
        flex: 1;
        width: 0;
        height: 22/20rem;
        line-height: 22/20rem;
        font-weight: 500;
        font-size: 16/20rem;
        letter-spacing: 0;
        text-align: center;
        color: #000;
      }
      .popup-header-left,
      .popup-header-right {
        width: 22/20rem;
        height: 22/20rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .c-bottom-popup-body {
      flex: 1;
      width: 100%;
      height: 0;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>
